import { Component, Inject, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime, filter, takeUntil, delay, map, tap } from 'rxjs/operators';
import { Produto } from '../../../../../shared/interfaces/produto';
import { ProdutoService } from '../../../../../shared/services/produto.service';
import { LayoutService } from '../../../../../shared/services/layout.service';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FatClassTipiService } from '../../../../../shared/services/fat-class-tipi.service';
import { FatClassFiscalService } from '../../../../../shared/services/fat-class-fiscal.service';
import { Estados } from '../../../../../shared/inmemory-db/estados';
import { ProdutoClassTrib } from '../../../../../shared/interfaces/produto-class-trib';
import { EnumAdapter } from '../../../../../shared/interfaces/enum-adapter';
import { ProdutoEnums } from '../../../../../shared/interfaces/produto-enums';
import { Aliquotas } from '../../../../../shared/interfaces/aliquotas';
import { FatClassTipi } from '../../../../../shared/interfaces/fat-class-tipi';
import { FatClassFiscal } from '../../../../../shared/interfaces/fat-class-fiscal';

@Component({
  selector: 'app-produto-trib-popup',
  templateUrl: './produto-trib-popup.component.html',
  styleUrls: ['./produto-trib-popup.component.scss'],
})
export class ProdutoTribPopupComponent implements OnInit, OnDestroy {
  public produtoForm: FormGroup;
  produto: Produto;
  layoutConf: any;
  selectedEstado: any;
  classTribs$: BehaviorSubject<ProdutoClassTrib[]> = new BehaviorSubject<ProdutoClassTrib[]>(null);
  estados: any[];
  cstContrib: EnumAdapter;
  cstNaoContrib: EnumAdapter;
  enums: ProdutoEnums;
  aliquotas: Aliquotas;
  isSaving = false;
  isAdding = false;
  searching = false;

  fatClassTipis: FatClassTipi[] = [];
  fatClassFiscais: FatClassFiscal[] = [];
  fatClassFiscaisEntrada: FatClassFiscal[] = [];

  private _onDestroy = new Subject<void>();

  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase(),
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ProdutoTribPopupComponent>,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private layout: LayoutService,
    private produtoService: ProdutoService,
    private fatClassTipiService: FatClassTipiService,
    private fatClassFiscalService: FatClassFiscalService,
    private cdr: ChangeDetectorRef,
    private snack: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.layoutConf = this.layout.layoutConf;
    this.produto = this.data.payload;
    this.buildProdutoForm(this.produto);
    this.estados = new Estados().estados;

    console.log('Iniciando ngOnInit com estados:', this.estados);

    this.loadInitialData()
      .then(() => {
        console.log('Dados iniciais updateFormWithInitialData');
        this.updateFormWithInitialData();
        console.log('Dados iniciais configurando filtros');
        this.configureSearchFilters();
        // Carrega as classes tributárias se o produto já tiver id
        if (this.produto?.id && this.produto.id > 0) {
          this.reloadProdutoClassTrib();
        }
        this.cdr.detectChanges();
      })
      .catch(error => {
        console.error('Erro no ngOnInit:', error);
      });
  }

  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  private updateFormWithInitialData(): void {
    console.log('Atualizando formulário com dados iniciais...');
    console.log('this.produto?.classorigem:', this.produto?.classorigemId);
    console.log('this.produto?.classtributaria:', this.produto?.classtributariaId);
    console.log('this.produto?.classtributariaNaoContribuinte:', this.produto?.classtributariaNaoContribuinteId);
    console.log('this.produto?.modalidadeBcIcms:', this.produto?.modalidadeBcIcms);
    console.log('this.produto?.modalidadeBcIcmsSt:', this.produto?.modalidadeBcIcmsSt);
    console.log('this.produto?.beneficioFiscal:', this.produto?.beneficioFiscal);
    console.log('this.produto?.codigoBeneficioFiscalUF:', this.produto?.codigoBeneficioFiscalUF);
    console.log('this.produto?.fatClassFiscal:', this.produto?.fatClassFiscal);
    console.log('this.produto?.fatClassFiscalEntrada:', this.produto?.fatClassFiscalEntrada);
    console.log('this.produto?.classtipi:', this.produto?.classtipi);
    console.log('this.produto?.cest:', this.produto?.cest);
    console.log('this.produto?.aliquotasNormalId:', this.produto?.aliquotasNormalId);
    console.log('this.produto?.aliqinssId:', this.produto?.aliqinssId);
    console.log('this.produto?.aliqirrfId:', this.produto?.aliqirrfId);
    console.log('this.produto?.aliquotasReducaosId:', this.produto?.aliquotasReducaosId);
    console.log('this.produto?.aliquotasReducaoeId:', this.produto?.aliquotasReducaoeId);
    console.log('this.produto?.aliquotasDiferimentoId:', this.produto?.aliquotasDiferimentoId);
    console.log('this.produto?.indIss:', this.produto?.indIss);
    console.log('this.produto?.aliquotaIpiSaida:', this.produto?.aliquotaIpiSaida);
    console.log('this.produto?.cstIpiSaida:', this.produto?.cstIpiSaida);
    console.log('this.produto?.aliquotaIpiEntrada:', this.produto?.aliquotaIpiEntrada);
    console.log('this.produto?.cstIpiEntrada:', this.produto?.cstIpiEntrada);
    console.log('this.produto?.aliquotaCofins:', this.produto?.aliquotaCofins);
    console.log('this.produto?.cstCofins:', this.produto?.cstCofins);
    console.log('this.produto?.aliquotaPis:', this.produto?.aliquotaPis);
    console.log('this.produto?.cstPis:', this.produto?.cstPis);
    console.log('this.produto?.codigoanp:', this.produto?.codigoanp);
    console.log('this.produto?.combNumeroBico:', this.produto?.combNumeroBico);
    console.log('this.produto?.combNumeroTanque:', this.produto?.combNumeroTanque);
    console.log('this.produto?.percentualGLP:', this.produto?.percentualGLP);
    console.log('this.produto?.percentualGasNatural:', this.produto?.percentualGasNatural);
    console.log('this.produto?.percentualGasNaturalImportado:', this.produto?.percentualGasNaturalImportado);
    console.log('this.produto?.valorPar:', this.produto?.valorPar);
    console.log('this.produto?.valorUnitBcIcmsStRetUltComp:', this.produto?.valorUnitBcIcmsStRetUltComp);
    console.log('this.produto?.valorUnitIcmsStRetUltComp:', this.produto?.valorUnitIcmsStRetUltComp);
    console.log('this.produto?.valorUnitBcIcmsStDestUltComp:', this.produto?.valorUnitBcIcmsStDestUltComp);
    console.log('this.produto?.valorUnitIcmsStDestUltComp:', this.produto?.valorUnitIcmsStDestUltComp);
    
    this.produtoForm.patchValue({
      classorigemId: this.produto?.classorigemId ?? 0,
      classtributariaId: this.produto?.classtributariaId ?? 0,
      classtributariaNaoContribuinteId: this.produto?.classtributariaNaoContribuinteId ?? 0,
      modalidadeBcIcms: this.produto?.modalidadeBcIcms ?? '3',
      modalidadeBcIcmsSt: this.produto?.modalidadeBcIcmsSt ?? '3',
      beneficioFiscal: this.produto?.beneficioFiscal ?? false,
      codigoBeneficioFiscalUF: this.produto?.codigoBeneficioFiscalUF ?? '',
      fatClassFiscal: this.produto?.fatClassFiscal ?? null,
      fatClassFiscalEntrada: this.produto?.fatClassFiscalEntrada ?? null,
      classtipi: this.produto?.classtipi ?? null,
      cest: this.produto?.cest ?? '',
      aliquotasNormalId: this.produto?.aliquotasNormalId ?? 0,
      aliqinssId: this.produto?.aliqinssId ?? 0,
      aliqirrfId: this.produto?.aliqirrfId ?? 0,
      aliquotasReducaosId: this.produto?.aliquotasReducaosId ?? 0,
      aliquotasReducaoeId: this.produto?.aliquotasReducaoeId ?? 0,
      aliquotasDiferimentoId: this.produto?.aliquotasDiferimentoId ?? 0,
      indIss: this.produto?.indIss ?? false,
      aliquotaIpiSaida: this.produto?.aliquotaIpiSaida ?? 0,
      cstIpiSaida: this.produto?.cstIpiSaida ?? '',
      aliquotaIpiEntrada: this.produto?.aliquotaIpiEntrada ?? 0,
      cstIpiEntrada: this.produto?.cstIpiEntrada ?? '',
      aliquotaCofins: this.produto?.aliquotaCofins ?? 0,
      cstCofins: this.produto?.cstCofins ?? '',
      aliquotaPis: this.produto?.aliquotaPis ?? 0,
      cstPis: this.produto?.cstPis ?? '',
      codigoanp: this.produto?.codigoanp ?? '',
      // combNumeroBico: isNaN(Number(this.produto?.combNumeroBico)) ? 0 : Number(this.produto?.combNumeroBico),
      // combNumeroTanque: isNaN(Number(this.produto?.combNumeroTanque)) ? 0 : Number(this.produto?.combNumeroTanque),
      percentualGLP: this.produto?.percentualGLP ?? 0,
      percentualGasNatural: this.produto?.percentualGasNatural ?? 0,
      percentualGasNaturalImportado: this.produto?.percentualGasNaturalImportado ?? 0,
      valorPar: this.produto?.valorPar ?? 0,
      valorUnitBcIcmsStRetUltComp: this.produto?.valorUnitBcIcmsStRetUltComp ?? 0,
      valorUnitIcmsStRetUltComp: this.produto?.valorUnitIcmsStRetUltComp ?? 0,
      valorUnitBcIcmsStDestUltComp: this.produto?.valorUnitBcIcmsStDestUltComp ?? 0,
      valorUnitIcmsStDestUltComp: this.produto?.valorUnitIcmsStDestUltComp ?? 0,
    });
  }

  private async loadInitialData(): Promise<void> {
    try {
      const [
        enums,
        aliquotas,
        classFiscaisPage,
        classFiscal,
        classFiscaisEntradaPage,
        classFiscalEntrada,
        ncmsPage,
        ncm
      ] = await Promise.all([
        this.produtoService.getEnums().toPromise(),
        this.produtoService.getAliquotas().toPromise(),
        this.fatClassFiscalService.getClassFiscalPage(1, 10).toPromise(), // Retorna Promise<PageResult<FatClassFiscal>>
        this.fatClassFiscalService.getClassFiscal(this.produto?.classfiscalId).toPromise(),
        this.fatClassFiscalService.getClassFiscalPage(1, 10).toPromise(), // Retorna Promise<PageResult<FatClassFiscal>>
        this.fatClassFiscalService.getClassFiscal(this.produto?.classfiscalEntradaId).toPromise(),
        this.fatClassTipiService.getFatClassTipPage(1, 10).toPromise(), // Retorna Promise<PageResult<FatClassTipi>>
        this.fatClassTipiService.getFatClassTipiNcm(this.produto?.classtipiCodigonbm).toPromise(),
      ]);

      console.log('Dados iniciais carregados com sucesso:', {
        enums,
        aliquotas,
        classFiscaisPage,
        classFiscal,
        classFiscaisEntradaPage,
        classFiscalEntrada,
        ncmsPage,
        ncm,
      });


      this.enums = enums;
      this.aliquotas = aliquotas;

      console.log('Class Fiscais:', classFiscaisPage);
      // Extrai os arrays de 'content'
      this.fatClassFiscais = classFiscaisPage.content || []; // FatClassFiscal[]
      console.log('Class Fiscais Entrada:', classFiscaisEntradaPage);
      this.fatClassFiscaisEntrada = classFiscaisEntradaPage.content || []; // FatClassFiscal[]
      console.log('NCMs:', ncmsPage);
      this.fatClassTipis = ncmsPage.content || []; // FatClassTipi[]

      console.log('Class Fiscais:', this.fatClassFiscais);
      if (classFiscal) {
        this.fatClassFiscais.push(classFiscal);
        this.produto.fatClassFiscal = classFiscal;
      }
      console.log('Class Fiscais Entrada:', this.fatClassFiscaisEntrada);
      if (classFiscalEntrada) {
        this.fatClassFiscaisEntrada.push(classFiscalEntrada);
        this.produto.fatClassFiscalEntrada = classFiscalEntrada;
      }
        
      console.log('NCM:', this.fatClassTipis);
      if (ncm) {
        this.fatClassTipis.push(ncm);
        this.produto.classtipi = ncm;
      }

      console.log('S U C E S S O : DADOS INICIAIS:');

    } catch (error) {
      console.error('Erro ao carregar dados iniciais:', error);
      this.snack.open('Erro ao carregar dados do produto!', 'OK', { duration: 3000 });
      throw error;
    }
  }

  private configureSearchFilters(): void {
    console.log('Configurando filtros de pesquisa...');
    this.produtoForm.get('searchClassFiscal')?.valueChanges.pipe(
      filter(search => !!search),
      tap(() => this.searching = true),
      debounceTime(200),
      map(search => this.fatClassFiscalService.getClassFiscalPageSearch(search, 1, 10).toPromise().then(res => res.content)),
      delay(500),
      takeUntil(this._onDestroy)
    ).subscribe(
      classFiscais => {
        this.searching = false;
        classFiscais.then(resolvedClassFiscais => {
          this.fatClassFiscais = resolvedClassFiscais;
        });
        this.updateSelectedValue('fatClassFiscal', this.produto.fatClassFiscal, this.fatClassFiscais);
      },
      error => this.handleSearchError(error)
    );

    this.produtoForm.get('searchClassFiscalEntrada')?.valueChanges.pipe(
      filter(search => !!search),
      tap(() => this.searching = true),
      debounceTime(200),
      map(search => this.fatClassFiscalService.getClassFiscalPageSearch(search, 1, 10).toPromise().then(res => res.content)),
      delay(500),
      takeUntil(this._onDestroy)
    ).subscribe(
      classFiscais => {
        this.searching = false;
        classFiscais.then(resolvedClassFiscais => {
          this.fatClassFiscaisEntrada = resolvedClassFiscais;
        });
        this.updateSelectedValue('fatClassFiscalEntrada', this.produto.fatClassFiscalEntrada, this.fatClassFiscaisEntrada);
      },
      error => this.handleSearchError(error)
    );

    this.produtoForm.get('searchClasstipi')?.valueChanges.pipe(
      filter(search => !!search),
      tap(() => this.searching = true),
      debounceTime(200),
      map(search => this.fatClassTipiService.getFatClassTipPageSearch(1, 10, search, null, null, false).toPromise().then(res => res.content)),
      delay(500),
      takeUntil(this._onDestroy)
    ).subscribe(
      ncms => {
        this.searching = false;
        ncms.then(resolvedNcms => {
          this.fatClassTipis = resolvedNcms;
        });
        this.updateSelectedValue('classtipi', this.produto.classtipi, this.fatClassTipis);
      },
      error => this.handleSearchError(error)
    );
  }

  private updateSelectedValue(controlName: string, selectedValue: any, options: any[]): void {
    if (selectedValue && !options.some(opt => opt.id === selectedValue.id || opt.codigoNcm === selectedValue.codigoNcm)) {
      options.push(selectedValue);
    }
    this.produtoForm.controls[controlName].setValue(selectedValue);
  }

  private handleSearchError(error: any): void {
    this.searching = false;
    this.confirmService.confirm({
      message: `A T E N Ç Ã O ! ERRO PESQUISANDO: ${error}`,
      error: true,
    });
  }

  buildProdutoForm(produto: Produto): void {
    this.produtoForm = this.fb.group({
      searchClasstipi: [""],
      searchClassFiscal: [""],
      searchClassFiscalEntrada: [""],
      id: [produto?.id],
      descricao: [produto.descricao],
      aliqirrfId: [produto?.aliqirrfId],
      aliqinssId: [produto?.aliqinssId],
      aliquotaCofins: [produto?.aliquotaCofins],
      aliquotaIpiEntrada: [produto?.aliquotaIpiEntrada],
      aliquotaIpiSaida: [produto?.aliquotaIpiSaida],
      aliquotaPis: [produto?.aliquotaPis],
      aliquotasDiferimentoId: [produto?.aliquotasDiferimentoId],
      aliquotasNormalId: [produto?.aliquotasNormalId],
      aliquotasReducaoeId: [produto?.aliquotasReducaoeId],
      aliquotasReducaosId: [produto?.aliquotasReducaosId],
      cest: [produto?.cest],
      classfiscalId: [produto?.classfiscalId],
      classfiscalEntradaId: [produto?.classfiscalEntradaId],
      fatClassFiscal: [produto?.fatClassFiscal],
      fatClassFiscalEntrada: [produto?.fatClassFiscalEntrada],
      modalidadeBcIcms: [produto?.modalidadeBcIcms],
      modalidadeBcIcmsSt: [produto?.modalidadeBcIcmsSt],
      classorigemId: [produto?.classorigemId],
      classtipiCodigonbm: [produto?.classtipiCodigonbm],
      classtipi: [produto?.classtipi],
      classtributariaId: [produto?.classtributariaId],
      classtributariaNaoContribuinteId: [produto?.classtributariaNaoContribuinteId],
      beneficioFiscal: [produto?.beneficioFiscal],
      codigoBeneficioFiscalUF: [produto?.codigoBeneficioFiscalUF],
      cstCofins: [produto?.cstCofins],
      cstIpiEntrada: [produto?.cstIpiEntrada],
      cstIpiSaida: [produto?.cstIpiSaida],
      cstPis: [produto?.cstPis],
      indIss: [produto?.indIss],
      codigoanp: [produto?.codigoanp],
      combNumeroBico: [produto?.combNumeroBico],
      combNumeroTanque: [produto?.combNumeroTanque],
      percentualGLP: [produto?.percentualGLP],
      percentualGasNatural: [produto?.percentualGasNatural],
      percentualGasNaturalImportado: [produto?.percentualGasNaturalImportado],
      valorPar: [produto?.valorPar],
      valorUnitBcIcmsStRetUltComp: [produto?.valorUnitBcIcmsStRetUltComp],
      valorUnitIcmsStRetUltComp: [produto?.valorUnitIcmsStRetUltComp],
      valorUnitBcIcmsStDestUltComp: [produto?.valorUnitBcIcmsStDestUltComp],
      valorUnitIcmsStDestUltComp: [produto?.valorUnitIcmsStDestUltComp],
    });
  }

  onSelectClassTipi(event: any): void {
    if (event.value) {
      this.produtoForm.patchValue({
        classtipiCodigonbm: event.value.codigoNcm,
        cest: event.value.cest,
      });
    }
  }

  onSelectClassFiscal(event: any): void {
    if (event.value) {
      this.produtoForm.patchValue({ classfiscalId: event.value.id });
    }
  }

  onSelectClassFiscalEntrada(event: any): void {
    if (event.value) {
      this.produtoForm.patchValue({ classfiscalEntradaId: event.value.id });
    }
  }

  addCstEstado(): void {
    const id = this.produtoForm.controls['id'].value;
    if (!id || id <= 0) {
      this.confirmService.confirm({ title: 'A T E N Ç Ã O !', message: 'Salve o cadastro de produto primeiro!', error: true });
      return;
    }

    this.isAdding = true;
    const trib: ProdutoClassTrib = {
      id: 0,
      uf: this.selectedEstado.uf,
      classtributariaId: this.cstContrib.codigo2,
      classtributariaNaoContribuinteId: this.cstNaoContrib.codigo2,
      fcpAliquota: 0,
      fcpSubstAliquota: 0,
      fcpSubstAnteriorAliquota: 0,
      uuid: '',
      issueDate: null,
      updatedAt: null,
      classTributaria: '',
      classTributariaNaoContribuinte: '',
      fatProduto: this.produto,
    };

    this.produtoService.saveOrUpdateClassTrib(trib).subscribe(() => {
      this.reloadProdutoClassTrib();
      this.isAdding = false;
    });
  }

  readEstado(uf: string): string {
    const estado = this.estados.find(val => val.uf === uf);
    return estado ? `${estado.estado}-${estado.uf}` : '';
  }

  readCst(cst: string): string {
    const cstFind = this.enums?.cst_ICMS.find(val => val.codigo2 === cst);
    return cstFind ? `${cstFind.codigo}-${cstFind.descricao}` : '';
  }

  deleteCst(id: number): void {
    this.produtoService.deleteProdutoClassTrib(id).subscribe(() => this.reloadProdutoClassTrib());
  }

  private reloadProdutoClassTrib(): void {
    this.produtoService.getClassTrib(this.produto?.id).subscribe(classTrib => this.classTribs$.next(classTrib));
  }

  submit(): void {
    if (this.produtoForm.valid) {
      this.save();
    } else {
      this.validateAllFormFields(this.produtoForm);
    }
  }

  save(): void {
    this.isSaving = true;
    this.produtoService.saveOrUpdate(this.produtoForm.value).subscribe(
      val => {
        this.confirmService.confirm({ title: 'S U C E S S O !', message: 'OK, TRIBUTAÇÃO SALVA COM SUCESSO ! ', icon: 'check_circle', error: false });
        // this.dialogRef.close(val);
      },
      err => {
        this.confirmService.confirm({ title: 'A T E N Ç Ã O  !', icon: 'error', message: err.error.status, error: true });
      }
    ).add(() => this.isSaving = false);
  }

  close(): void {
    this.dialogRef.close();
  }

  private validateAllFormFields(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      } else {
        if (control) {
          control.markAsTouched({ onlySelf: true });
        }
      }
    });
  }
}